import {Route} from '@config/routes';
import {redirect} from 'next/navigation';
import {getLocale} from './getLocale';
import {getPrependLocale} from './prependLocale';

export const redirectToNotFound = async () => {
    const locale = await getLocale();
    redirect(getPrependLocale(Route.NOT_FOUND, locale));
};
